import { useState } from 'react';
import api from '../utils/api';

export default function GenerateFteInvoiceModal({ workOrder, onClose, onGenerated }) {
  const [form, setForm] = useState({ invoice_number: '', invoice_date: '', due_date: '', notes: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  async function handleGenerate() {
    if (!form.invoice_number || !form.invoice_date) {
      setError('Invoice number and date are required');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const r = await api.post(`/work-orders/${workOrder.id}/generate-fte-invoice`, form);
      setResult(r.data);
      onGenerated?.();
    } catch (e) {
      setError(e.response?.data?.error || 'Could not generate invoice');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="import-modal" style={{ width: 480 }} onClick={e => e.stopPropagation()}>
        <div className="drawer-header">
          <h3 className="drawer-title">Generate FTE Placement Invoice</h3>
          <button className="drawer-close" onClick={onClose}>×</button>
        </div>

        <div style={{ padding: 24 }}>
          <div style={{ background: 'var(--surface)', borderRadius: 'var(--radius)', padding: 14, marginBottom: 20, fontSize: 13 }}>
            For Work Order <strong>{workOrder.client_wo_number}</strong> — one-time fee of{' '}
            <strong>${(workOrder.fte_fee_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</strong>
          </div>

          {error && (
            <div style={{ background: 'var(--danger-bg)', color: 'var(--danger-text)', padding: '10px 14px', borderRadius: 'var(--radius)', fontSize: 13, marginBottom: 18 }}>
              {error}
            </div>
          )}

          {result && (
            <div style={{ background: 'var(--success-bg)', color: 'var(--success-text)', padding: 14, borderRadius: 'var(--radius)', fontSize: 14, marginBottom: 18 }}>
              AR Invoice created for ${result.amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}.
            </div>
          )}

          {!result && (
            <div className="form-grid">
              <div className="form-field span-2">
                <label>Invoice number</label>
                <input value={form.invoice_number} onChange={e => setForm(f => ({ ...f, invoice_number: e.target.value }))} placeholder="TMV/MMM/YYYY-NN" autoFocus />
              </div>
              <div className="form-field">
                <label>Invoice date</label>
                <input type="date" value={form.invoice_date} onChange={e => setForm(f => ({ ...f, invoice_date: e.target.value }))} />
              </div>
              <div className="form-field">
                <label>Due date</label>
                <input type="date" value={form.due_date} onChange={e => setForm(f => ({ ...f, due_date: e.target.value }))} />
              </div>
              <div className="form-field span-2">
                <label>Notes</label>
                <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} />
              </div>
            </div>
          )}
        </div>

        <div className="drawer-footer">
          {result ? (
            <button className="btn btn-primary" onClick={onClose}>Done</button>
          ) : (
            <>
              <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
              <button className="btn btn-primary" onClick={handleGenerate} disabled={saving}>
                {saving ? 'Generating…' : 'Generate Invoice'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
